module.exports = __webpack_public_path__ + "img/Haar-Wassen.dc96482c.jpg";